import React from 'react';

import { FORM_ERROR } from 'final-form';

import { SimpleObject } from '@hrlogics/helper-types';

import { CompanyType, useValidateSignupEmployeePinOrSsnLazyQuery } from 'src/api';
import { FORM_ERROR_KEY } from 'src/constants/signup';
import { SsnFormValues } from 'src/types/signup';

import { useNotification } from '../app';

type SsnFormSubmitHandlerHookParams = {
  companyId: string;
  companyType: CompanyType;
  updateFormData: (data: SimpleObject) => void;
  setEmployeeSignupToken: (token: string | null) => void;
  goToNextStep: () => void;
};

export const useSsnFormSubmitHandler = ({
  companyId,
  companyType,
  updateFormData,
  setEmployeeSignupToken,
  goToNextStep,
}: SsnFormSubmitHandlerHookParams) => {
  const { createApolloContext } = useNotification();

  const [validateSignupSsnOrPin] = useValidateSignupEmployeePinOrSsnLazyQuery({
    context: createApolloContext(),
  });

  const handleSsnFormSubmit = React.useCallback(
    async (formValues: SsnFormValues) => {
      const { data } = await validateSignupSsnOrPin({
        variables: {
          pinOrSsn: formValues.ssn,
          companyId,
          companyType,
        },
      });

      const employeeSignupToken = data?.validateSignupEmployeePinOrSsn.employeeSignupToken;
      if (!employeeSignupToken) {
        return { [FORM_ERROR]: FORM_ERROR_KEY.SSN_NOT_FOUND };
      }

      updateFormData({ ssn: formValues.ssn });
      setEmployeeSignupToken(employeeSignupToken);
      return goToNextStep();
    },
    [
      companyId,
      companyType,
      validateSignupSsnOrPin,
      updateFormData,
      setEmployeeSignupToken,
      goToNextStep,
    ],
  );

  return { handleSsnFormSubmit };
};
